import "./style/main.scss";
import App from './components/App.svelte';
const app = new App({
    target: document.querySelector('#single-station-radio-player'),
    props: {
        name: 'single-station-radio-player'
    }
});
export default app;
